import type { Breakpoint } from '../Image.types'

export const breakpoints: Breakpoint[] = ['xl', 'lg', 'md', 'sm']
